const getMs = seconds => seconds * 1000

export { getMs }
